module.exports = __webpack_public_path__ + "static/media/VestasSans-Semibold.ae89bb0d.eot";